angular.module("contractSelectedTable.components", []).component("contractSelectedTable", {
    templateUrl: "ng/components/munAuthorization/contractSelectedTable/contractSelectedTable.view.html",
    bindings: {
        contractSelected: "<",
        dettaglioSelected: "&",
        searchLoader: '<',
        enableDisabledCheck: '<',
        prodottoImmobiliare: '<',
        riscattoAnticipato: '<',
        isRiscattoTermine: '<'
    },
    controllerAs: "contractSelTableCtrl",
    controller: ContractSelTableCtrl
});

function ContractSelTableCtrl() {
    var self = this;

    self.supportModel = {
        selectDeselectAll: {
            selected: false,
            showVarIndirizzi: false
        }
    }

    self.$onInit = function () {
        self.firstStepOnPage = true;

        if (self.isRiscattoTermine) {
            self.contractSelected = self.contractSelected.map(x => {

                Object.assign(x, {
                    numero: x.numeroContratto,
                    modulo: x.numeroModulo
                })
                return x;
            })
        }
    };

    self.$onChanges = function (changed) {
        if (self.supportModel && changed.varIndirizzo &&
            typeof changed.varIndirizzo.currentValue != "undefined") {
            self.supportModel.showVarIndirizzi = changed.varIndirizzo.currentValue;
        }

        if (changed.enableDisabledCheck.currentValue != "undefined") {
            self.enableDisabledCheck = changed.enableDisabledCheck.currentValue
            self.supportModel.selectDeselectAll.selected = self.enableDisabledCheck
            self.selectedDeselectedAll(self.supportModel.selectDeselectAll, true)

        }
    }

    self.onCheckboxChange = function (el) {
        el.selected = !el.selected;

        self.dettaglioSelected({
            dettaglio: self.contractSelected
        })
    }

    self.selectedDeselectedAll = function (element, fromInputChange) {
        checkIfCheckboxDisabled();
        if (!fromInputChange) {
            element.selected = !element.selected;
        }
        if (self.prodottoImmobiliare) {
            element.selected = true;
        }
        if (self.firstStepOnPage || self.prodottoImmobiliare) {
            self.contractSelected.forEach(function (dettaglio) {
                dettaglio.selected = element.selected;
            })
        }

        self.dettaglioSelected({
            dettaglio: self.contractSelected
        })
    }

    var checkIfCheckboxDisabled = function () {

        if (self.prodottoImmobiliare) {
            self.valueDisabledCheck = true;
        } else if (!self.prodottoImmobiliare && self.enableDisabledCheck) {
            self.valueDisabledCheck = true;
        } else {
            self.valueDisabledCheck = false;
        }


    }
}